import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { OrderIndData } from "../types";

export const createOrderIndApi = (userId: string, orderInd: OrderIndData) =>{

    console.log("CREATE orderInd:", orderInd);
  console.log("CREATE userId:", userId);

  
    return webApiWithResponse<string>({
    method: "POST",
    url: "order/insertorderindicative",
    params: {
      userId,
    },
    data: orderInd,
  });
}
export default createOrderIndApi;
